<template>
    <form @submit.prevent="submit()">
        <div id="accordionpage" class="accordion accordion-page">
            <draggable v-model="data"  @start="drag=true" @end="drag=false">
                <div v-for="element in data" :key="element.id" class="card stage-block">
                    <a href="javascript:void(0);" data-level="1" data-toggle="collapse" :data-target="'#collapse'+element.id" aria-expanded="false" :aria-controls="'collapse'+element.id" class="btn-link collapsed">
                        <div :id="'heading'+element.id" class="card-header">
                            <h2 class="beneficiaries">{{element.question}}   </h2><span class="know-more hidden">Conocer m&aacute;s</span>
                        </div>
                    </a>
                    <div :id="'collapse'+element.id" data-level="1" :aria-labelledby="'heading'+element.id" data-parent="#accordionpage" class="collapse" aria-expanded="false" style="height: 0px;">
                        <div class="card-body" v-html="element.answer">
                            
                        </div>
                    </div>
                    <div class="line-left"></div>
                </div>        
            </draggable>
        </div>
        <div class="row">
            <div class="col-xs-12 text-center">
                <a class="btn btn-default" :href="'backend/faqs/'+this.faq.id+'/topics/'+this.topic.id">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>    
</template>
<style lang="scss" scoped>
    .wrapper-drag {
        display: flex;
    }
    
    /*** */

    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: none;
        border-radius: 10px;
        padding: 12px 18px 18px;
        margin-bottom: 25px;
        font-weight: 400;
        overflow: hidden;
        -webkit-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        -moz-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
    }
    .accordion-page .card.stage-block .btn-link, main #page .accordion-page .card.stage-block .card-body {
        padding: 30px 20px 30px 30px;
        background-color: transparent;
    }
    .accordion-page .card a.btn-link {
        display: block;
        color: #000;
        text-decoration: none;
    }
    .life-stages .accordion-page .card.stage-block a.btn-link .card-header h2 {
        color: #000000;
        font-size: 28px;
        margin: 0;
        font-family: Roboto Slab,sans-serif;
    }
    .card.stage-block a, .card.stage-block a:hover, .card.stage-block a h2, .card.stage-block a:hover h2 {
        text-decoration: underline!important;
        color: #240003!important;
    }
    
    .life-stages.container .beneficiaries {
        border-bottom: none;
        width: 85%;
    }
    .faq-alert.life-stages .line-left {
        background: #0080ec;
    }
    .line-left {
        height: 100%;
        position: absolute;
        top: 0;
        width: 12px;
        background: #0080ec;
        left: 0;
    }
    
    .card.stage-block .know-more {
        position: absolute;
        display: block;
        right: 20px;
        top: calc(50% - 10px);
        color: #337ab7;
    }
    .accordion-page .card.stage-block .btn-link, main #page .accordion-page .card.stage-block .card-body {
        padding: 30px 20px 30px 30px;
        background-color: transparent;
    }
    .card-body {
        margin-left: 13px;
        padding-top: 18px;
        padding-bottom: 13px;
    }
    .card.stage-block p {
        font-size: 16px;
    }
</style>
<script>
import draggable from 'vuedraggable';

//transform object to array for draggable manipulation
function valuesToArray(obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
}

export default {
    data: function(){
        
        const arr = valuesToArray(this.questions);
        return {
            data: _.cloneDeep(arr),
            errors: {}
        }
    },
    props: ['topic','faq','questions'],
    components: {
        draggable,
    },
    methods: {
        submit: function() {
            var self = this;

            axios({
                url: 'backend/faqs/'+self.faq.id+'/topics/'+self.topic.id+'/order',
                method: 'POST',
                data: self.data,
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        }        
    },
}
</script>